import React, { useContext } from "react";
import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router-dom";
import FilterContext from "../utils/FilterContext";
import { getDefaultFiltersForRoute } from "../config/filterDeafault";
import Cookies from 'js-cookie';
// import AxiosInstance from "../utils/AxiosInstance";
import isEqual from "lodash.isequal";
import { useConfig } from "../utils/ConfigContext.jsx";
import {createAxiosInstance} from "../utils/AxiosInstance";
const Breadcrumb = ({ title }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { API_BASE_URL } = useConfig(); // ✅ from context

  // Access filter data and setter function from context
  const { filters, setFilters } = useContext(FilterContext);


  // Function to remove a filter by key
  // const handleRemoveFilter = (key) => {
  //   const defaultFilter = getDefaultFiltersForRoute(currentPath);
  //   console.log("filter hai", filters);
  //   console.log("deafault filter hai", filters);

  //   // Prevent removing default values
  //   if (filters[key] === defaultFilter[key]) {
  //     alert("This is the default filter and cannot be removed.");
  //     return;
  //   }

  //   const newFilters = {
  //     ...filters,
  //     [key]: defaultFilter[key], // Set value to empty
  //   };

  //   // Save filters to a cookie with a path-specific key
  //   const cookieKey = `filters_${currentPath}`;
  //   Cookies.set(cookieKey, JSON.stringify(newFilters), { expires: 7 });


  //   // Update both global filters and route-specific filters
  //   setFilters(newFilters);
  //   // updateRoutesFilters(currentPath, newFilters);
  // };

  const handleRemoveFilter = (key) => {
    const defaultFilter = getDefaultFiltersForRoute(currentPath);

    // Compare values deeply (handles objects & primitives)
    const isDefault = isEqual(filters[key], defaultFilter[key]);

    if (isDefault) {
      alert("This is the default filter and cannot be removed.");
      return;
    }

    // Reset this key to default (if exists) or null
    const newFilters = {
      ...filters,
      [key]: defaultFilter.hasOwnProperty(key) ? defaultFilter[key] : null
    };

    // Save updated filters to cookie
    const cookieKey = `filters_${currentPath}`;
    Cookies.set(cookieKey, JSON.stringify(newFilters), { expires: 7 });

    // Update context
    setFilters(newFilters);
  };

  // funtion for export data
  const handleExportData = async () => {
    // console.log("ahaaa apan bhai")
    try {

      let startDate = null;
      let endDate = null;

      // function for change YYYY-MM-DD TO DD-MM-YYYY
      const convertToDDMMYYYY = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
      };

      // const filters = filtersRef.current;
      // console.log("date", filters);
      if (filters?.dateRange) {
        const [start, end] = filters.dateRange.split(" - ");
        if (start && end) {
          startDate = convertToDDMMYYYY(start.trim());
          endDate = convertToDDMMYYYY(end.trim());
        }
      }
       const AxiosInstance = createAxiosInstance(API_BASE_URL);
      // https://erp.saaol.com/api/v1/export-assistant-doctor-report?startdate=01-06-2025&enddate=01-06-30
      const response = await AxiosInstance.get("export-assistant-doctor-report", {
        params: {
          startdate: startDate,
          enddate: endDate,
        },
      });

      // console.log(response.data);

    } catch (error) {
      console.error("Error fetching data:", error);
    }

  }

  // console.log("filter data : ", filters)
  return (
    <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
      <div className="d-flex gap-2 align-items-center">
        <h6 className='fw-semibold mb-0'>{title}</h6>

        {/* Render filter badges only if there is data */}
        {Object.entries(filters)
          .filter(([_, value]) => value) // Ensure value is not empty or undefined
          .map(([key, value]) => (
            <span key={key} className="badge text-sm fw-semibold bg-light-600 px-20 py-9 radius-4 text-dark">
              {typeof value === 'object' && value.label ? value.label : value}
              {/* {value} */}
              <i
                className="ri-close-line ms-2 text-danger"
                style={{ cursor: "pointer" }}
                onClick={() => handleRemoveFilter(key)} // Remove the filter on click
              ></i>
            </span>
          ))}

      </div>

      <ul className='d-flex flex-wrap align-items-center gap-2'>
        {/* {currentPath === "/doctor_revenue" && <li onClick={() => handleExportData()}><img className="hover_export" src="/assets/images/export.png" alt="export" width={"35px"} title="export data" /></li>
        } */}
        <li className='fw-medium'>
          <Link
            to='/'
            className='d-flex align-items-center gap-1 hover-text-primary'
          >
            <Icon
              icon='solar:home-smile-angle-outline'
              className='icon text-lg'
            />
            Dashboard
          </Link>
        </li>
        <li> - </li>
        <li className='fw-medium'>{title}</li>
      </ul>
    </div>
  );
};

export default Breadcrumb;
